/* eslint-disable */
import config from "../config";

type PlanKey = keyof typeof config.subscriptionPlans;
type PromoPlanKey = keyof typeof config.promoCodePlans;

const isPlanKey = (key: string): key is PlanKey =>
  key in config.subscriptionPlans;

const isPromoPlanKey = (key: string): key is PromoPlanKey =>
  key in config.promoCodePlans;

const initialTierMRR = {
  STARTER: 0,
  GROWTH: 0,
  BUSINESS: 0,
};

const resolvePlanAmount = (name: string): number | null => {
  const lower = name.toLowerCase();
  const upper = name.toUpperCase();

  if (isPlanKey(lower)) {
    return config.subscriptionPlans[lower].amount;
  }

  if (isPromoPlanKey(upper)) {
    return config.promoCodePlans[upper].amount;
  }

  return null;
};

export const generateTotalMRRWithBreakdown = (
  tierData: Array<{ name: string; value: number }>
) => {
  let totalMRR = 0;

  // 1. First collect raw MRR per tier
  const tierMRR = tierData.reduce<Record<string, number>>((acc, { name, value }) => {
    const amount = resolvePlanAmount(name);
    if (!amount) return acc;

    totalMRR += value * amount;

    acc[name.toUpperCase()] = value * amount
    return acc;
  }, { ...initialTierMRR })


  // 2. Convert to formatted output
  const breakdown = Object.entries(tierMRR).map(([tier, amount]) => {
    const percentage = totalMRR === 0
      ? 0
      : (amount / totalMRR) * 100;

    return {
      tier,
      value: `$${amount.toLocaleString()}`,
      percentage: `${percentage.toFixed(1)}%`,
    };
  });

  return {
    totalMRR,
    breakdown
  };
};
